<template>
    <section class="app-main">

        
        <div class="top-bar">
            <el-input  v-model="shop" @change="handleShop"  placeholder="输入店铺名称查询" prefix-icon="el-icon-search" clearable style="width:220px;margin-right:20px;"></el-input>
            <el-input  v-model="title" @change="handleTitle"  placeholder="输入订单号查询" prefix-icon="el-icon-search" clearable style="width:220px;margin-right:20px;"></el-input>
            <el-input  v-model="barcode" @change="handleBarcode"  placeholder="输入条形码查询" prefix-icon="el-icon-search" clearable style="width:220px;margin-right:20px;"></el-input>
            <el-date-picker v-model="month" type="month" value-format="yyyy-MM" placeholder="月份筛选" @change="handleMonth" style="width:230px"></el-date-picker>
            <el-select v-model="classId" @change="searchClass()" placeholder="省份筛选" style="width:240px;margin-left:20px;">
                <el-option v-for="(it, index) in province" :key="index" :value="it.id" :label="it.abbreviation"></el-option>
            </el-select>
            <el-button type="success" plain  style="width:120px;margin-left:20px;" @click="onSend()">导出报表</el-button>
        </div>
        
    
        <!-- 商品列表 -->
        <el-card >
            <el-table ref="table" :data="tableData" :cell-style="handleCell" height="578" >
                <el-table-column label="日期"  min-width="170" align="center">
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        <span style="margin-left: 10px">{{ scope.row.sales_date }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_number" label="订单号"  align="center" min-width="170"></el-table-column>
                <el-table-column prop="store_name" label="店铺名称" align="center" > </el-table-column>
                <el-table-column prop="payment_method" label="支付方式" align="center" > </el-table-column>
                <el-table-column prop="shipping_fee" label="邮费"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.shipping_fee}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_price" label="实付金额"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.order_price}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="refund_price" label="退款金额"  align="center" >
                    <template slot-scope="scope">
                        <span>{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.refund_price}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="self_pick" label="是否自提"  align="center" > </el-table-column>
                <el-table-column prop="sales_province" label="销售省份"  align="center" > </el-table-column>
                <el-table-column prop="totalMoney" label="订单详情"  align="center"  >
                    <template slot-scope="scope">
                        <el-popover  placement="top-end" width="120
                        0" trigger="click">
                            <el-table :data="scope.row.goods_list" max-height="300">
                                <el-table-column label="商品图片"  align="center" width="100">
                                    <template slot-scope="scope">
                                        <m-img v-if="scope.row.goods_sku_pic_url" :src=" scope.row.goods_sku_pic_url" />
                                    </template>
                                </el-table-column>
                                <el-table-column label="商品名称" show-overflow-tooltip  align="center" width="200">
                                    <template slot-scope="scope">{{scope.row.goods_name}}</template>
                                </el-table-column>
                                <el-table-column label="商品规格"  align="center"  width="140" show-overflow-tooltip>
                                    <template slot-scope="scope">{{scope.row.sku_name}}</template>
                                </el-table-column>
                                <el-table-column label="条形码"  align="center"  width="160">
                                    <template slot-scope="scope">{{scope.row.barcode}}</template>
                                </el-table-column>
                                <el-table-column label="退款数量"   align="center" width="80">
                                    <template slot-scope="scope">{{scope.row.after_sales_number}}</template> 
                                </el-table-column>
                                <el-table-column label="退款金额"  align="center">
                                    <!-- <template slot-scope="scope">{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{(scope.row.goods_price - scope.row.goods_discount_fee - scope.row.goods_wallet_fee ).toFixed(2)}}</template>  -->
                                    <template slot-scope="scope">{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{scope.row.goods_price}}</template> 
                                </el-table-column>
                                <el-table-column label="退款税费"  align="center">
                                    <template slot-scope="scope">{{scope.row.trans_currency == 'USD' ? 'US$': 'C$'}}{{ scope.row.goods_tax_price }}</template> 
                                </el-table-column>
                            </el-table>
                            <el-button slot="reference" type="primary" plain size="mini">查看详情</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next" style="padding:15px" :total="total" :page-size="size" ></el-pagination>
        </el-card>



    </section>
</template>



<script>
import { reimburse } from '@/api/platform.js'
import MImg   from './../../../components/Image'
export default {
    components: { MImg },
    data() {
        return {
            shop: '',
            title: '',
            barcode: '',
            month: '',
            classId:'',
            province: [],
            tableData:[],
            status:0,
            total:0,
            page:1,
            size: 10,
        }
    },
    methods: {
        getData(){
            let params = {
                page:this.page
            }
            if(this.shop != ""){
                params.shops_title = this.shop;
            }
            if(this.title != ""){
                params.order_title = this.title;
            }
            if(this.barcode != ""){
                params.barcode = this.barcode;
            }
            if(this.month != ""){
                params.month = this.month
            }
            if (this.classId != "") {
                params.province_id = this.classId
            }
            reimburse(params).then(res => {
                if(res){
                    this.tableData = res.data.list.data
                    this.tableData.forEach(item => {
                        item.goods_list.forEach(it => {
                            it.trans_currency = item.trans_currency
                        })
                    })
                    this.province = res.data.province
                    this.total = res.data.list.total
                }else{
                    this.tableData = [];
                    this.total = 0;
                }
            })
        },
        // 商家搜索
        handleShop(){
            this.title = ''
            this.barcode = ''
            this.classId = ''
            this.month = ''
            this.page = 1
            this.getData()
        },
        // 订单号搜索
        handleTitle(){
            this.shop = ''
            this.barcode = ''
            this.classId = ''
            this.month = ''
            this.page = 1
            this.getData()
        },
         // 条形码搜索
        handleBarcode(){
            this.title = ''
            this.month = ''
            this.classId = ''
            this.page = 1
            this.getData()
        },
        // 月份搜索
        handleMonth(){
            this.title = ''
            this.classId = ''
            this.page  = 1
            this.getData()
        },
        searchClass() {
            this.title = ''
            this.shop = ''
            this.barcode = ''
            this.month = ''
            this.page = 1
            this.getData()
        },
        // 点击页数 加载当前点击页的数据
        reloadData(page){
            this.page = page
            this.getData()
        },
         // 确认导出
        onSend(){
            if (!this.month) {
                this.$message({ type:'error', message:'请先选择月份！' })
                return false
            }else{
                var a = document.createElement("a");
                a.href = `https://admintapi.moobyyoho.com/finance/refund-report-export?month=${this.month}`;
                a.click();
            }
            
        },
        // 设置cell 格式
        handleCell(obj ) {
            if([3,4].includes(obj.columnIndex)){
                return 'color:red'
            }
            if([7].includes(obj.columnIndex)){
                return 'color: #67c23a'
            }
           
        },

      
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    /deep/ .el-tag + .el-tag{ 
        margin-left: 20px;
    }
    
}
</style>
